import React from 'react';
import { Alert, AlertTitle, Box } from '@mui/material';
import { Error as ErrorIcon, Security as SecurityIcon } from '@mui/icons-material';
import { getErrorMessage, isPermissionError } from '../../utils/errorUtils';
import { useDirection } from '../../context/DirectionContext';
import { translate as tr } from '../../i18n/translations';

interface ErrorAlertProps {
  error: any;
  title?: string;
}

const ErrorAlert: React.FC<ErrorAlertProps> = ({ error, title }) => {
  const { lang } = useDirection();
  const isPermission = isPermissionError(error);
  const errorMessage = getErrorMessage(error);
  
  return (
    <Alert 
      severity={isPermission ? 'warning' : 'error'}
      icon={isPermission ? <SecurityIcon /> : <ErrorIcon />}
      sx={{ mb: 2 }}
    >
      {title && <AlertTitle>{title}</AlertTitle>}
      <Box component="span" sx={{ wordBreak: 'break-word' }}>
        {errorMessage}
      </Box>
      {isPermission && (
        <Box sx={{ mt: 1, fontSize: '0.875rem', opacity: 0.8 }}>{tr('err.contactAdmin', lang)}</Box>
      )}
    </Alert>
  );
};

export default ErrorAlert;